const SOFTWARE_INDUSTRIES = new Set([
  "ecommerce",
  "professional_services",
  "legal_accounting_services",
  "education_training",
  "saas_software_development",
  "digital_products",
]);

export interface InferExonerationSuggestionResult {
  /** Preset legend option id, e.g. `servicios_irae`. */
  suggestedLegendId: string;
  /** i18n key under `settings.fiscalProfile.*` */
  hintKey: "inferExonerationHintServiciosIrae";
}

/**
 * Non-mutating hint for invoice legend: software + export → suggest IRAE servicios art. 52.
 * Does not auto-select; UI shows a hint only.
 */
export function inferExonerationSuggestion(
  industry: string | null | undefined,
  isExportingServices: boolean
): InferExonerationSuggestionResult | null {
  if (!isExportingServices) return null;
  const ind = industry?.trim() ?? "";
  if (!ind || !SOFTWARE_INDUSTRIES.has(ind)) return null;
  return {
    suggestedLegendId: "servicios_irae",
    hintKey: "inferExonerationHintServiciosIrae",
  };
}
